"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZhHantLocale = exports.EnLocale = exports.CUSTOMIZED = exports.COMPANY_NAME = exports.PHONE = exports.NAME = exports.CONTENT = exports.EMAIL = void 0;
exports.EMAIL = 'senderEmail';
exports.CONTENT = 'content';
exports.NAME = 'name';
exports.PHONE = 'phone';
exports.COMPANY_NAME = 'companyName';
exports.CUSTOMIZED = 'customized';
exports.EnLocale = 'EN';
exports.ZhHantLocale = 'ZH_HANT';
